import * as React from 'react';
import { Box } from '@apia/theme';

export interface IDialogButtonBar {
  children: React.ReactNode;
  className?: string;
}

const DialogButtonBar = ({
  children,
  className,
}: IDialogButtonBar): JSX.Element => {
  return (
    <Box
      className={`${className ?? ''} buttonsBar`}
      {...window.getVariant('layout.common.modals.buttonsBar')}
    >
      {children}
    </Box>
  );
};

export default DialogButtonBar;
